import { DrawerSheet } from '../drawer-sheet';
import { WalletBalance } from './wallet-balance';
import { WalletHeader } from './wallet-header';
import { WalletInterest } from './wallet-interest';
import { cn } from '@/client/utils';

type UserWalletModelProps = {
  className?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
};
export const UserWalletModel = ({ className, open, setOpen }: UserWalletModelProps) => {
  return (
    <DrawerSheet
      open={open}
      setOpen={setOpen}
      side="right"
      className={cn('rounded-t-3 md:rounded-none w-full md:w-[407px] space-y-5 md:space-y-9', className)}
    >
      <WalletHeader setOpen={setOpen} />
      <WalletBalance />
      <WalletInterest />
    </DrawerSheet>
  );
};
